// These utils are needed to correctly handle special characters like " and \ in criterion values. See NPT-12809 and NPT-13240

export const escapeSpecialCharacters = (value: string) =>
  value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

export const unescapeSpecialCharacters = (value: string) =>
  value.replace(/\\\\/g, '\\').replace(/\\"/g, '"');
